'use client';

import { Textfit } from 'react-textfit';

export { Textfit };
